module.exports = __webpack_public_path__ + "img/gigastore-lp-api.065c13f8.png";